module.exports = __webpack_public_path__ + "img/4taskStatus.64e80cf7.svg";